import {
  COMENZAR_LOGIN,
  EVENTO_LOGIN_EXITO,
  EVENTO_LOGIN_ERROR,
  EVENTO_LOGOUT_EXITO,
  EVENTO_LOGOUT_ERROR,
  RESET_ERROR_LOGIN
} from "../types";

import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";
import { setCookie, removeCookie } from "../../utils/cookieUtils";

const SESSION_HOURS = 24;

export function loginUsuarioAction(credenciales, navigate) {
  return async (dispatch) => {
    dispatch(inicioLoginEvento());
    await clienteAxios
      .post(`/login`, {
        email: credenciales.usuario,
        password: credenciales.contrasena,
      })
      .then((respuesta) => {
        const { usuario, token } = respuesta.data;
        setCookie("user", JSON.stringify(usuario), SESSION_HOURS);
        setCookie("token", token, SESSION_HOURS);
        dispatch(inicioLoginEventoExitosa(respuesta.data));
        navigate("/panel", { replace: true });
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          err.response.statusText = err.response.data.msg;
        }
        dispatch(inicioLoginEventoError(handlerError(err)));
      });
  };
}

const inicioLoginEvento = () => ({
  type: COMENZAR_LOGIN,
  payload: true,
});

const inicioLoginEventoError = (error) => ({
  type: EVENTO_LOGIN_ERROR,
  payload: error,
});

const inicioLoginEventoExitosa = (data) => ({
  type: EVENTO_LOGIN_EXITO,
  payload: data,
});

export function logoutUsuarioAction() {
  return async (dispatch) => {
    try {
      removeCookie("user");
      removeCookie("token");
      dispatch(logoutEventoExitoso());
    } catch (error) {
      dispatch(logoutEventoError());
    }
  };
}

const logoutEventoExitoso = () => ({
  type: EVENTO_LOGOUT_EXITO,
  payload: true,
});

const logoutEventoError = () => ({
  type: EVENTO_LOGOUT_ERROR,
  payload: true,
});


export function resetErrorLoginAction() {
  return async (dispatch) => {
      dispatch(resetErrorLoginEvento());
  };
}

const resetErrorLoginEvento = () => ({
  type: RESET_ERROR_LOGIN,
  payload: true,
});
